export const LMT_ENHCMT_setBankStatementPasswordReducer = {
  LMT_ENHCMT_setBankStatementPassword: (state, action) => {
    state.bankStatementPassword = action.payload;
  },
};
